import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  addMaliciousWord,
  deleteMaliciousWord,
  getMaliciousWords,
  updateMaliciousWords,
} from "store/services/dataManagement/maliciousWords";
import { closeAdminModal } from "store/slices/common/adminModal.slice";
import { openToast } from "store/slices/common/toast.slice";
import { getApiMessage } from "utils/apiErrorCode";

export const GetAllMaliciousWords = createAsyncThunk(
  "maliciousWords/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getMaliciousWords(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const UpdateMaliciousWords = createAsyncThunk(
  "maliciousWords/update",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { onSuccess, onError, ...data } = payload;
    try {
      const res = await updateMaliciousWords(data);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data

        if (onSuccess) onSuccess(res);
        dispatch(closeAdminModal());
        return fulfillWithValue(res);
      }
      if (onError) onError(res);
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const AddMaliciousWords = createAsyncThunk(
  "maliciousWords/add",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { onSuccess, onError, filter, ...data } = payload;
    try {
      const res = await addMaliciousWord(data);
      if (res.status === 1) {
        if (onSuccess) onSuccess();
        dispatch(closeAdminModal());
        const listRes = await getMaliciousWords(filter);
        return fulfillWithValue(listRes);
      }
      if (onError) onError(res);
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const DeleteMaliciousWords = createAsyncThunk(
  "maliciousWords/delete",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { onSuccess, onError, filter, id } = payload;
      const res = await deleteMaliciousWord(id);

      if (res.status === 1) {
        if (filter) {
          const listRes = await getMaliciousWords(filter);
          if (listRes.status === 1) {
            if (onSuccess) onSuccess(listRes);
            return fulfillWithValue(listRes);
          } else {
            if (onSuccess) onSuccess(res);
            return fulfillWithValue(res);
          }
        } else {
          if (onSuccess) onSuccess(res);
          return fulfillWithValue(res);
        }
      } else {
        if (onError) onError(res);
        dispatch(
          openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
        );
        return rejectWithValue(res);
      }
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);
